__webpack_require__.p = "/energy/water/paper/Ecosystem_Services_Karnataka/";